<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-8">
        <!-- 저장하기 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="save">개설하기</button>
        </div>
      </div>
      <div class="column is-8">
        <div class="box">
          <admin-box-item title="서비스 정보">
            <admin-form-item label="사용자(이메일 계정)">
              <lp-adm-drop-input :data="users"
                                 @onSelect="selectUser"
                                 added_field="type"
                                 placeholder="검색 후 선택"
                                 width="250px"
                                 listAlign="center"
                                 style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
            </admin-form-item>
            <admin-form-item label="복제할 테마 선택">
              <lp-adm-drop-input :data="products"
                                 @onSelect="selectProduct"
                                 added_field="type"
                                 placeholder="검색 후 선택"
                                 width="250px"
                                 listAlign="center"
                                 style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
            </admin-form-item>
            <admin-form-item label="서비스명" style="margin-top:20px">
              <input class="input"
                     style="width:250px"
                     :value="value.service_name"
                     @input="e => value.service_name = e.target.value"
                     type="text" maxlength="30">
            </admin-form-item>
            <admin-form-item label="서비스 키 (영문 소문자로 시작, 영문 소문자+숫자조합)" style="margin-top:20px">
              <input class="input"
                     :value="value.key"
                     @input="e => value.key = e.target.value"
                     style="width:140px"
                     type="text" maxlength="30"><span style="line-height:32px;margin-left:8px">.launchpack.co.kr</span>
            </admin-form-item>

            <admin-form-item label="PC 모드 지원 여부">
              <lp-radio :val.sync="value.pc_mode"
                        value_name="value"
                        label_name="label"
                        :data="[{label: 'PC+Mobile', value: true}, {label: 'Mobile', value: false}]"></lp-radio>
            </admin-form-item>

            <admin-form-item label="플러그인" style="margin-top:20px">
              <lp-check-group-boolean :list="plugins"></lp-check-group-boolean>
            </admin-form-item>

          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import LpCheckGroupBoolean from "../../../module/common/LpCheckGroupBoolean";
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import LpRadio from "../../../module/common/LpRadio";

  export default {
    name: "service-reg",
    components: {
      LpRadio,
      LpAdmDropInput,
      LpCheckGroupBoolean
    },
    created() {
      this.getProducts();
      this.getUserList();
      this.getPlugins();
    },
    data() {
      return {
        products: [],
        users: [],
        plugins: [],
        value: {
          service_name: '',
          key: '',
          plugins: [],
          product_id: 0,
          user_id: 0,
          pc_mode: true
        }
      }
    },
    methods: {
      getProducts() {
        this.$axios.get('user/0/mapping/product?&category=40&fields=id,name,theme_key&page_num=1&page_length=30').then(res=>{
          this.products = res.data.data.map(i=>{
            return {
              label: i.name,
              name: i.name,
              value: i.id,
              theme_key: i.theme_key
            }
          });
        });
      },
      selectUser(res) {
        this.value.user_id = res.value;
      },
      selectProduct(res) {
        this.value.product_id = res.value;
        // 플러그인 기본 선택 하기
        this.$axios.get(`https://${res.theme_key}.launchpack.co.kr/api/public/ui/brand/admin`).then(res=>{
          this.plugins.forEach(p=>{
            p.is_active = res.data.plugins.indexOf(p.name)>-1;
          });
        });
      },
      getUserList() {
        this.$axios.get('admin/user/simple').then(res => {
          this.users = res.data;
        });
      },
      getPlugins() {
        this.$axios.get('admin/launchpack/internal_plugin?page_length=200').then(res => {
          this.plugins = res.data.data.map(i => {
            return {
              label: i.label,
              name: i.value,
              is_active: false
            }
          }).sort((a,b)=> {
            return a.label > b.label ? 1 : -1;
          })
        });
      },
      isValid() {
        let result = true;
        if(this.value.user_id === 0) {
          this.toast('사용자를 선택해주세요.');
          result = false;
        }
        else if(this.value.product_id === 0) {
          this.toast('복제할 테마를 선택해주세요.');
          result = false;
        }
        else if(this.value.key.trim()==='') {
          this.toast('서비스 키를 입력해주세요.');
          result = false;
        }

        return result;
      },
      async save() {
        if(!this.isValid()) {
          return;
        }
        let param = this.cloneItem(this.value);
        let user = this.users.filter(i=>{ return i.value === this.value.user_id })[0];
        param.name = user.name;
        param.phone = user.phone;
        param.email = user.email;

        let res = await this.$axios.post(`public/product/${param.product_id}/selector_stocks`);
        let option_id = res.data.stocks.filter(i=>{ return i.label.indexOf('바로 개설') > -1 })[0].id;

        param.order_product = {
          product_id: param.product_id,
          order_product_option: [
            {
              option_id: option_id
            }
          ]
        };
        param.plugins = this.plugins.filter(i=> { return i.is_active }).map(i=>{ return i.name });

        this.$axios.post('admin/launchpack/v1/service', param).then(res=>{
          if(res.status === 200) {
            this.toast('서비스가 개설 중입니다.');
            setTimeout(()=>{
              this.routerPush('/office/admin/launchpack/service');
            },300);
          }
        });
      }
    }


  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
